export default "__VITE_ASSET__C4a18bw8__"